module.exports = __webpack_public_path__ + "static/media/user-secret.316235a7.svg";